import { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

export const useCantidadFiltrosAplicados = ({
  mapaFiltros,
  contextoFiltros,
  filtrosVisibles,
  buscador
}) => {
  const { categoriasPath, filtrosLocales } = useSelector((state) => state.filters)
  const filtrosSeleccionados = useSelector(
    (state) => state.filters.filtrosSeleccionados,
    shallowEqual
  )

  const entradasFecha = useMemo(
    () =>
      mapaFiltros
        ? Object.entries(mapaFiltros)
            .filter(([, c]) => c.tipo === 'fecha')
            .map(([key]) => ({ key }))
        : [],
    [mapaFiltros]
  )

  const filtrosFijosValues = useMemo(() => {
    if (!mapaFiltros) return []
    return Object.entries(mapaFiltros)
      .filter(([campo, config]) => {
        if (!config.opciones) return false
        if (filtrosVisibles?.length) return filtrosVisibles.includes(campo)
        return true
      })
      .map(([campo, config]) => {
        const key = typeof config.key === 'function' ? config.key(contextoFiltros) : campo
        return filtrosLocales[key]
      })
  }, [mapaFiltros, contextoFiltros, filtrosLocales, filtrosVisibles])

  const filtrosArbolEmpresaUsuario = [
    filtrosLocales.compradorEmpresa,
    filtrosLocales.compradorUsuario,
    filtrosLocales.vendedorEmpresa,
    filtrosLocales.vendedorUsuario
  ].filter((v) => v).length

  return (
    (categoriasPath.length > 0 ? 1 : 0) +
    Object.values(filtrosSeleccionados).filter((v) => v).length +
    (buscador && buscador.valor ? 1 : 0) +
    (filtrosLocales.precioDesde || filtrosLocales.precioHasta ? 1 : 0) +
    entradasFecha.filter((e) => filtrosLocales[e.key]).length +
    filtrosFijosValues.filter((v) => v !== undefined && v !== null && v !== '').length +
    filtrosArbolEmpresaUsuario
  )
}
